import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';

import { AlertModalTemplateModule } from '@shared/components/alert-modal-template/alert-modal-template.module';
import { MerchantInfoBarComponent } from '@shared/components/merchant-info-bar/merchant-info-bar.component';
import { TableOrderScheduleComponent } from '@shared/components/td-store/order-policy/table-order-schedule/table-order-schedule.component';
import { PureFnModule } from '@shared/pipes/pure-fn/pure-fn.module';
import { StoreService } from '@shared/services/store.service';
import { SharedModule } from '@shared/shared.module';

import { StoreCreateButtonComponent } from './components/store-create-button/store-create-button.component';
import { StoreImportOrderScheduleComponent } from './components/store-import-order-schedule/store-import-order-schedule.component';
import { StoreListComponent } from './store-list/store-list.component';
import { StoreRequestListComponent } from './store-request-list/store-request-list.component';
import { StoreRequestComponent } from './store-request/store-request.component';
import { StoreRouting } from './store-routing.module';
import { StoreComponent } from './store.component';
import { StoreEffects } from './store/store.effects';
import { storeModuleReducers } from './store/store.reducers';
import { TerminateStoreModalComponent } from './terminate-store/terminate-store-modal/terminate-store-modal.component';
import { TerminateStoreComponent } from './terminate-store/terminate-store.component';
import { POSTerminalComponent } from './view-store/pos-terminal/pos-terminal.component';
import { RegisterPOSComponent } from './view-store/register-pos/register-pos.component';
import { StoreDeviceComponent } from './view-store/store-device/store-device.component';
import { ViewStoreComponent } from './view-store/view-store.component';

@NgModule({
  declarations: [
    StoreComponent,
    StoreListComponent,
    StoreRequestComponent,
    StoreRequestListComponent,
    ViewStoreComponent,
    RegisterPOSComponent,
    POSTerminalComponent,
    TerminateStoreModalComponent,
    TerminateStoreComponent,
    StoreDeviceComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    StoreRouting,
    TranslateModule.forChild(),
    StoreModule.forFeature('store', storeModuleReducers.store),
    EffectsModule.forFeature([StoreEffects]),
    PureFnModule,
    AlertModalTemplateModule,
    TableOrderScheduleComponent,
    MerchantInfoBarComponent,
    StoreCreateButtonComponent,
    StoreImportOrderScheduleComponent
  ],
  providers: [StoreService]
})
export class TDStoreModule {}
